import Tone from 'tone'

export default ([
  {
    id: 1,
    name: 'one',
    track: new Tone.Player({
      url: './Scratches/scratch1.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1
    }).toMaster()
  },
  {
    id: 2,
    name: 'two',
    track: new Tone.Player({
      url: './Scratches/scratch2.mp3',
      fadeIn: 0.1,
      fadeOut: 0.1
    }).toMaster()
  }
])


// WEBPACK FOOTER //
// ./src/Scratch/scratchData.js